<script lang="ts">
	import type { Snippet } from 'svelte';
	import { TabsContext, setTabsContext } from './tabs.context.svelte';

	interface Props {
		activeTab: string;
		children: Snippet;
	}
	let { activeTab, children }: Props = $props();

	const ctx = new TabsContext();
	$effect(() => {
		ctx.activeTab = activeTab;
	});
	setTabsContext(ctx);
</script>

{@render children()}
